import { gql } from '@apollo/client';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import { WrapMaybe } from 'src/components/wrapMaybe/WrapMaybe';
import Config from 'src/lib/config';
import { format } from 'src/lib/format';
import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { setOverlayVisibleLocation } from 'src/lib/routing';

import { FederatedGraphBadge } from '../federatedGraphBadge/FederatedGraphBadge';

export const FederatedGraphWidgetGraphVariantFragment = gql`
  fragment FederatedGraphWidgetGraphVariantFragment on GraphVariant {
    id
    latestApprovedLaunch {
      id
      buildInput {
        ... on CompositionBuildInput {
          version
        }
      }
    }
    latestLaunch {
      id
      build {
        id
        result {
          ... on BuildFailure {
            errorMessages {
              message
              code
            }
          }
        }
      }
      buildInput {
        ... on CompositionBuildInput {
          version
        }
      }
    }
  }
`;

export const FederatedGraphWidget = ({
  buildErrors,
  compositionVersion,
}: {
  buildErrors: GraphQLTypes.FederatedGraphWidgetGraphVariantFragment_latestLaunch_build_result_BuildFailure_errorMessages[];
  compositionVersion?: string | null;
}) => {
  const location = useLocation();
  const hasErrors = buildErrors.length > 0;

  return (
    <Tooltip
      label={`Build has failed. There ${
        buildErrors.length === 1 ? 'is' : 'are'
      } ${buildErrors.length} build ${format.pluralize(
        buildErrors.length,
        'error',
      )}.`}
      placement="right"
      disabled={!hasErrors}
    >
      <WrapMaybe
        element={
          <Link
            to={setOverlayVisibleLocation({
              location,
              overlayName: Config.modals.buildErrors,
            })}
          />
        }
        on={hasErrors}
      >
        <FederatedGraphBadge
          version={compositionVersion}
          hasErrors={hasErrors}
        />
      </WrapMaybe>
    </Tooltip>
  );
};
